import { METRIC_DEFINITIONS } from '../constants/metrics';

const MetricsSummaryGrid = ({ metrics, teamColor }) => (
  <div className="metrics-summary">
    <h3>Ключевые показатели</h3>
    <div className="metrics-grid">
      {METRIC_DEFINITIONS.map(({ key, title }) => (
        <div key={key} className="metric-card">
          <h4>{title}</h4>
          <div className="metric-value">{metrics[key].toFixed(1)}%</div>
          <div className="metric-bar">
            <div
              className="metric-fill"
              style={{
                width: `${metrics[key]}%`,
                backgroundColor: teamColor || '#3bbddb',
              }}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default MetricsSummaryGrid;
